import MenuItem from "@mui/material/MenuItem";
// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";

const CustomMenuItem = styled(MenuItem)({
  "&.MuiMenuItem-root": {
    fontFamily: "Proxima Nova",
    padding: "12px 2em 12px 2em",
    fontSize: "1rem",
    color: "gray",
    borderLeft: "none",
  },
  "&.Mui-selected": {
    borderLeft: "none",
    color: "gray",
  },
});

export default CustomMenuItem;
